"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelizeKeys = camelizeKeys;
exports.decamelizeKeys = decamelizeKeys;
exports.omitUndefined = omitUndefined;
exports.parseObject = parseObject;
exports.getLpAuthCookie = getLpAuthCookie;
exports.getDataAtPath = getDataAtPath;
exports.ensureAsync = ensureAsync;
exports.asyncReduce = asyncReduce;
exports.attemptAsync = attemptAsync;
Object.defineProperty(exports, "isError", {
  enumerable: true,
  get: function get() {
    return _isError["default"];
  }
});
Object.defineProperty(exports, "get", {
  enumerable: true,
  get: function get() {
    return _get["default"];
  }
});
Object.defineProperty(exports, "set", {
  enumerable: true,
  get: function get() {
    return _set["default"];
  }
});
Object.defineProperty(exports, "unset", {
  enumerable: true,
  get: function get() {
    return _unset["default"];
  }
});
Object.defineProperty(exports, "compose", {
  enumerable: true,
  get: function get() {
    return _compose["default"];
  }
});
Object.defineProperty(exports, "noop", {
  enumerable: true,
  get: function get() {
    return _noop["default"];
  }
});
Object.defineProperty(exports, "union", {
  enumerable: true,
  get: function get() {
    return _union["default"];
  }
});
Object.defineProperty(exports, "isString", {
  enumerable: true,
  get: function get() {
    return _isString["default"];
  }
});
exports.identity = void 0;

var _humps = _interopRequireDefault(require("humps"));

var _omitBy = _interopRequireDefault(require("lodash/omitBy"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _isError = _interopRequireDefault(require("lodash/isError"));

var _attempt = _interopRequireDefault(require("lodash/attempt"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _isPromise = _interopRequireDefault(require("is-promise"));

var _get = _interopRequireDefault(require("lodash/fp/get"));

var _set = _interopRequireDefault(require("lodash/fp/set"));

var _unset = _interopRequireDefault(require("lodash/fp/unset"));

var _compose = _interopRequireDefault(require("lodash/fp/compose"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _union = _interopRequireDefault(require("lodash/union"));

var _isString = _interopRequireDefault(require("lodash/isString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// A wrapper around the humps library
// Converts all keys of the given object to camelCase
// EXCEPT keys that begin with an underscore to
// support specific keys such as the `_error`
// key used by Redux Form to communicate errors
// that are not tied to specific form fields.
function camelizeKeys(obj) {
  return _humps["default"].camelizeKeys(obj, function (key, convert) {
    return /^_/.test(key) ? key : convert(key);
  });
} // A wrapper around the humps library
// Converts all keys of the given object to lower_case


function decamelizeKeys(obj) {
  return _humps["default"].decamelizeKeys(obj);
} // Given an object, returns a copy of that object
// with all keys with undefined values removed


function omitUndefined(obj) {
  return (0, _omitBy["default"])(obj, _isUndefined["default"]);
} // Parses an object from a string and returns the result
// Returns undefined if there's a parsing error


function parseObject(str) {
  var parsedObj = (0, _attempt["default"])(function () {
    return JSON.parse(str);
  });
  if (!(0, _isError["default"])(parsedObj)) return parsedObj;
} // Gets the auth cookie used by lp_token_auth
// Returns undefined if the cookie is not set


function getLpAuthCookie() {
  return _jsCookie["default"].get('lp_auth');
} // Gets data at path if path exists,
// otherwise returns full object


function getDataAtPath(obj, path) {
  return path ? (0, _get["default"])(path, obj) : obj;
} // Identity function (lodash one hasn't been working for some reason)


var identity = function identity(i) {
  return i;
}; // Creates a version of a function that returns a promise if it doesn't already


exports.identity = identity;

function ensureAsync(func) {
  return function () {
    var value = func.apply(void 0, arguments);
    return (0, _isPromise["default"])(value) ? value : Promise.resolve(value);
  };
} // Async version of array.reduce() that allows the accumulator function to return a promise.
// https://blog.bloomca.me/2018/01/27/asynchronous-reduce-in-javascript.html


function asyncReduce(_x, _x2, _x3) {
  return _asyncReduce.apply(this, arguments);
} // Async version of lodash attempt()
// https://lodash.com/docs/4.17.15#attempt


function _asyncReduce() {
  _asyncReduce = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(array, handler, initialValue) {
    var result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, value;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            result = initialValue;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 4;
            _iterator = array[Symbol.iterator]();

          case 6:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 14;
              break;
            }

            value = _step.value;
            _context.next = 10;
            return handler(result, value);

          case 10:
            result = _context.sent;

          case 11:
            _iteratorNormalCompletion = true;
            _context.next = 6;
            break;

          case 14:
            _context.next = 20;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 20:
            _context.prev = 20;
            _context.prev = 21;

            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }

          case 23:
            _context.prev = 23;

            if (!_didIteratorError) {
              _context.next = 26;
              break;
            }

            throw _iteratorError;

          case 26:
            return _context.finish(23);

          case 27:
            return _context.finish(20);

          case 28:
            return _context.abrupt("return", result);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 16, 20, 28], [21,, 23, 27]]);
  }));
  return _asyncReduce.apply(this, arguments);
}

function attemptAsync(_x4) {
  return _attemptAsync.apply(this, arguments);
}

function _attemptAsync() {
  _attemptAsync = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(func) {
    var _len,
        args,
        _key,
        _args2 = arguments;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            for (_len = _args2.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = _args2[_key];
            }

            _context2.next = 4;
            return func.apply(void 0, args);

          case 4:
            return _context2.abrupt("return", _context2.sent);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", _context2.t0);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return _attemptAsync.apply(this, arguments);
}